import { memo } from 'react';

export const WorkspaceSidebarBoardsListItemSkeleton = memo(() => {
  return (
    <div className="flex h-8 w-full cursor-progress items-center gap-2 px-2">
      <div className="size-4 shrink-0 rounded-4 bg-grey-5" />
      <div className="h-5 w-full rounded-4 bg-grey-5" />
    </div>
  );
});

WorkspaceSidebarBoardsListItemSkeleton.displayName = 'WorkspaceSidebarBoardsListItemSkeleton';
